import { render, staticRenderFns } from "./RelatoriosIAConsumo.vue?vue&type=template&id=9593b5a8"
import script from "./relatorios/RelatoriosIAConsumo.js?vue&type=script&lang=js&external"
export * from "./relatorios/RelatoriosIAConsumo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports